import '../sass/index.scss';
import Time from '@utils/performance/TimeManager.js';
import QualityManager from '@utils/performance/QualityManager.js';
import DeviceManager from '@utils/device/DeviceManager.js';
import DebugManager from '@utils/debug/DebugManager.js';
import { initWebgl } from './webgl/core/GL.js';
import webglConfig from './webgl/webgl.js';
import { map, format } from "./utils/utilsFunc.js";
import Page from './engine/Page.js';
import Lenis from 'lenis';
import Preloader from './preloader/Preloader.js';

export default class App {
  constructor(options) {
    this.container = options.dom;
    this.lenis = new Lenis()

    this.stop = false;

    this.debugBoundsGUI = null

    this.timePaused = true;
    this.isFinished = false;

    this.isLoaded = false;

    this.size = {
      x: window.innerWidth,
      y: window.innerHeight
    }

    this.ratioScreen = this.size.x / this.size.y
    this.devicePixelRatio = window.devicePixelRatio;

    this.deviceManager = new DeviceManager();
    this.debugManager = new DebugManager();

    this.GL = initWebgl(webglConfig)

    this.qualityManager = new QualityManager()
    this.GL.setQualityManager(this.qualityManager)
    this.debugManager.initQuality(this.qualityManager)
    this.debugManager.initPreloader()

    this.deviceManager.gpuDetectionFinished.then(() => {
      this.deviceManager.updateQuality(this.qualityManager.quality ?? this.deviceManager.gpu.qualityIndex)
    })

    this.pageGL = new Page({ parent: this, size: this.size })

    this.params = {
      global: {
      },
    }

    this.isMobile = window.matchMedia('(pointer: coarse)').matches
    const promises = []

    Promise.all(promises)
      .then(() => {
        this.paramsGlobal = this.params.global;

        this.bindMethods();
        this.getElems();
        this.init(options)
        this.events()

        this.debug()

        Time.add(this.render)
        Time.start()
      })


  }

  getElems() {
    this.mainContent = document.querySelector('main')
  }

  bindMethods() {
    this.render = this.render.bind(this)
    this.resize = this.resize.bind(this)
  }

  events() {
    window.addEventListener('resize', this.resize)
    window.addEventListener('orientationchange', this.resize)
  }

  init(options) {
    const promises = []

    promises.push(this.pageGL.init(), this.pageGL.initAssets())

    this.preloaderEl = document.querySelector('#preloader')
    this.preloader = this.preloaderEl ? Preloader(this.preloaderEl) : null
    this.preloader?.enter()

    const skipPreloader = sessionStorage.getItem('debug:skip-preloader') === 'true'

    Promise.all(promises)
      .then(() => {
        this.isLoaded = true;
        this.pageGL.ready({}); // Call ready method after assets are loaded
        this.resize();

        // Show main content once everything is ready
        this.mainContent.style.visibility = 'visible';
      })
      .then(() => {
        if (skipPreloader) this.preloaderEl?.remove()
        else this.preloader?.exit(() => {})
      });
  }

  resize() {
    this.devicePixelRatio = window.devicePixelRatio;
    this.size.x = window.innerWidth;
    this.size.y = window.innerHeight;

    this.GL.resize()

    this.pageGL.resize(this.size, this.devicePixelRatio)
  }

  render() {
    this.lenis.raf(Time.elapsed)

    if (!this.isLoaded) return;

    const cpuStart = performance.now()

    this.GL.update()
    this.GL.render()

    this.pageGL.update({
      time: Time.elapsed / 1000,
      deltaTime: Time.clampedDt / 1000
    })

    this.qualityManager.setCpuTime(performance.now() - cpuStart)
  }

  debug() {
    if (this.debugManager.disabled) return
    this.pageGL.debugMode(this.debugManager.folders.page)
  }

}

new App({
  dom: document.querySelector('.app')
});
